export enum StripeSubscriptionStatus {
  active = 1,
  canceled = 2,
  ended = 3,
  incomplete = 4,
  incomplete_expired = 5,
  past_due = 6,
  trialing = 7,
  unpaid = 8,
}